<template>
  <button
    type="button"
    class="button is-white is-borderless is-shadowless is-radiusless is-full-width is-justify-content-flex-start is-flex is-align-items-center has-border-top-light p-y-8 p-x-10"
    :data-e2e="FormCypressAttribute.buttons.FORM_SELECT_ADD_OPTION_ROW"
    @mousedown.prevent
    @click.stop="$emit('click')"
  >
    <i
      class="icon cls cls-add is-size-7 has-text-link has-background-grey-lightest is-circular is-flex-shrink-0 has-width-25 has-height-25 is-inline-flex is-align-items-center is-justify-content-center has-line-height-1"
      :data-e2e="FormCypressAttribute.views.FORM_SELECT_ADD_OPTION_ROW_ICON"
    />
    <div class="m-l-5">
      <slot />
    </div>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { FormCypressAttribute } from '@/modules/core/form/constants/FormCypressAttribute';

export default defineComponent({
  name: 'FormSelectAddOptionRow',
  emits: ['click'],
  static: {
    FormCypressAttribute
  }
});
</script>
